import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { IOtpState } from "models/Slices/otpSlice.model";
import { otpAsync } from "redux/actions/Otp.action";
import { IUserOtp } from "models/Otp/otp.model";

const initialState: IOtpState = {
  userOtp: null,
  loading: false,
  error: "",
  errorAlert: "",
  success: false,
  IsIgsLocked: false,
};

export const otpSlice = createSlice({
  name: "otp",
  initialState,
  reducers: {
    resetOtp: (state) => {
      state.success = false;
      state.loading = false;
      state.userOtp = null;
      state.error = "";
      state.errorAlert = "";
    },
    resetOtpError: (state) => {
      state.error = "";
    },
    resetOtpErrorAlert: (state) => {
      state.errorAlert = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(otpAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(otpAsync.fulfilled, (state, action: PayloadAction<IUserOtp>) => {
        state.loading = false;
        state.userOtp = action.payload;
        state.success =
          state.userOtp?.Confirm! || state.userOtp?.DialogBoxes?.length === 0;
        state.IsIgsLocked = state.userOtp.IsIgsLocked!;
      })
      .addCase(otpAsync.rejected, (state, action: any) => {
        state.loading = false;

        const errSplit = action.error?.message.split("#");
        if (errSplit[0] === "COR-50451") {
          state.errorAlert = errSplit[1];
        } else {
          state.error = errSplit[1];
        }
        state.success = false;
      });
  },
});

export const { resetOtp, resetOtpError, resetOtpErrorAlert } = otpSlice.actions;

export const selectSuccess = (state: RootState) => state.otp.success;
export const selectIsIgsLocked = (state: RootState) => state.otp.IsIgsLocked;
export const selectOtpAccessToken = (state: RootState) =>
  state.otp.userOtp?.access_token;

export default otpSlice.reducer;
